import * as SecureStore from 'expo-secure-store';
import { Platform } from 'react-native';

// AFTER_FIRST_UNLOCK (iOS only) so the app can still read and write the session
// while the phone is locked, e.g. when a push or VoIP call launches it in the
// background. expo-secure-store applies it only when it creates an item; writes
// to an existing item keep that item's setting.
const SECURE_STORE_OPTIONS: SecureStore.SecureStoreOptions = {
  keychainAccessible: SecureStore.AFTER_FIRST_UNLOCK,
};

const Storage = {
  async setItem(key: string, value: string): Promise<void> {
    if (Platform.OS === 'web') {
      sessionStorage.setItem(key, value);
    } else {
      await SecureStore.setItemAsync(key, value, SECURE_STORE_OPTIONS);
    }
  },

  async getItem(key: string): Promise<string | null> {
    if (Platform.OS === 'web') {
      return sessionStorage.getItem(key);
    }
    return SecureStore.getItemAsync(key);
  },

  async removeItem(key: string): Promise<void> {
    if (Platform.OS === 'web') {
      sessionStorage.removeItem(key);
    } else {
      await SecureStore.deleteItemAsync(key);
    }
  },
};

export default Storage;
